/** Root of the route tree: renders the active route. Providers are set up in app/app_providers.tsx. */
import { Outlet } from '@tanstack/react-router';

export function RootLayout() {
  return <Outlet />;
}
